var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNovoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.323,
    height: 33.918,
    viewBox: "0 0 21.323 33.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7072",
    "data-name": "Group 7072",
    transform: "translate(-1484.932 -677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7069",
    "data-name": "Group 7069",
    transform: "translate(1461 -282.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18948",
    "data-name": "Path 18948",
    d: "M26.919,959.362v9.209l4.221,1.691v-10.9Zm7.651,12.279Zm0,0c-.624.013.66,0,.024,0h-.024Z",
    fill: "#17256b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18953",
    "data-name": "Path 18953",
    d: "M34.593,973.943Zm0,0-2.962,6.068L25,980.982l4.8,4.713-1.127,6.667,5.924-3.143,5.924,3.143L39.39,985.7l4.8-4.712-6.631-.975-2.962-6.066Z",
    fill: "#f3f7ff",
    stroke: "#e5c588",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18954",
    "data-name": "Path 18954",
    d: "M32.675,959.362v11.524l1.895.755,1.943-.779v-11.5Zm1.895,12.279c-.624.013.66,0,.024,0h-.024Z",
    transform: "translate(1461 -282.362)",
    fill: "#ca373c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18955",
    "data-name": "Path 18955",
    d: "M38.046,959.362V970.25l4.221-1.679v-9.209Z",
    transform: "translate(1461 -282.362)",
    fill: "#17256b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18956",
    "data-name": "Path 18956",
    d: "M34.569,971.641Zm0,0a1.163,1.163,0,1,0,.024,0h-.024Zm.024,2.3h0Z",
    transform: "translate(1461 -282.362)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovoice);
export default __webpack_public_path__ + "static/media/novoice.54545785fbd6c798791af4906aa93e0c.svg";
export { ForwardRef as ReactComponent };